import { useQuery } from "@tanstack/react-query";
import { getRouteApi } from "@tanstack/react-router";
import { useCallback } from "react";

import type { UpdateArtistDirectorySearch } from "@/features/feature-page/artist-directory";
import type { ArtistDirectorySearchState } from "@/features/feature-page/artist-directory-query";
import { getFeaturePageQueryOptions } from "@/features/feature-page/feature-page-query";
import { FeaturePageView } from "@/features/feature-page/feature-page-view";
import type { FeaturePageFamily } from "@garimpa/lib/featurePage";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

const routeApi = getRouteApi("/_app/$lang/$family/$slug/");

export function FeaturePageRouteContent({
  family,
  slug,
  locale,
}: {
  family: FeaturePageFamily;
  slug: string;
  locale: ViewerLocale;
}) {
  const search = routeApi.useSearch() as ArtistDirectorySearchState;
  const navigate = routeApi.useNavigate();
  const updateDirectorySearch = useCallback<UpdateArtistDirectorySearch>(
    (updater, options) => {
      navigate({
        search: updater,
        replace: options?.replace ?? false,
        resetScroll: false,
      });
    },
    [navigate],
  );
  const pageQuery = useQuery(getFeaturePageQueryOptions({ family, slug, locale }));
  const page = pageQuery.data;
  if (!page) return null;
  return (
    <FeaturePageView
      page={page}
      directorySearch={search}
      updateDirectorySearch={updateDirectorySearch}
    />
  );
}
